export interface LinkFooterSubItem {
  label: string;
  routerUrl: string;
}
